<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.show.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <template #top>
      <resource-action-header :model="model" :action="'show'"></resource-action-header>
      <slot name="top" />
    </template>
    <div class="row mb-2">
      <div
        v-for="(groups, section) in model.presentation.sections"
        :key="section"
        :class="'col-' + (section === 'core_data' || section === 'meta_data' ? '6' : '12')"
      >
        <div v-for="(columns, group) in groups" :key="group" :class="Object.keys(columns).length > 0 ? '' : 'd-none'">
          <element-collection
            v-if="section !== 'has_many_relation_data' && section !== 'media_data'"
            :columns="columns"
            :field-group="group"
            :model="model"
          ></element-collection>
          <div v-if="section === 'has_many_relation_data'">
            <card
              v-for="(relatedKey, name) in columns"
              :key="name"
              :title="trans('models.' + resourceType + '.relations.' + name)"
              :options="{ style: { card: 'margin-bottom: 1rem;' } }"
            >
              <resource-collection
                :collection-type="model.data.collections[name].meta.config.component?.type ?? 'list'"
                :foreign-name="name"
                :mode="'component'"
                :models="model.data.collections[name]"
                :name="name"
                :parent-model="model"
                :parent-resource="resourceType"
              ></resource-collection>
            </card>
          </div>
          <div v-if="section === 'media_data' && model.data.media">
            <template v-for="(media, name) in columns">
              <card
                v-if="model.data.media[name]"
                :key="name"
                :title="trans('models.' + resourceType + '.attributes.' + name)"
                :options="{ style: { card: 'margin-bottom: 1rem;' } }"
              >
                <media-collection :media="model.data.media[name]"></media-collection>
              </card>
            </template>
          </div>
        </div>
      </div>
    </div>
    <template #right>
      <admin-sidebox :resource="model"></admin-sidebox>
    </template>
  </Layout>
</template>

<script>
import { ref } from 'vue';
import useResource from '@kanrisha/composables/useResource';

import AdminSidebox from '@kanrisha/components/Layout/AdminSidebox';
import Card from '@kanrisha/components/Base/Card';
import ElementCollection from '@kanrisha/components/Presentation/ElementCollection.vue';
import Layout from '@kanrisha/Pages/Layout';
import MediaCollection from '@kanrisha/components/Presentation/MediaCollection.vue';
import ResourceActionButtons from '@kanrisha/components/Links/ResourceActionButtons';
import ResourceActionHeader from '@kanrisha/components/Layout/ResourceActionHeader';
import ResourceCollection from '@kanrisha/components/ResourceCollection';

export default {
  components: {
    AdminSidebox,
    Card,
    ElementCollection,
    Layout,
    MediaCollection,
    ResourceActionButtons,
    ResourceActionHeader,
    ResourceCollection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['addToast'],
  setup(props) {
    const localModel = ref(props.model);
    const { meta, resourceType } = useResource(props, props.model);

    return {
      localModel,
      meta,
      resourceType,
    };
  },
};
</script>
